<template>
    <span :class="['progress', progressStatus]">
    </span>
</template>

<script>
export default {
    name: 'quest-progress-icon',

    props: {
        progress: {
            type: Object,
            required: true
        }
    },

    computed: {
        progressStatus() {
            if(!this.progress || this.progress.total === 0)
                return ''
            if(this.progress.completed === this.progress.total)
                return 'full'
            else if(this.progress.completed === 0)
                return 'none'
            else
                return 'some'
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";

.progress {
    width: 8px;
    height: 8px;
    border-radius: 100%;
    background-color: transparent;
    &.none {
        display: inline-block;
        background-color: $danger-color;
        margin-right: 4px;
    }
    &.full {
        display: inline-block;
        background-color: $success-color;
        margin-right: 4px;
    }
    &.some {
        display: inline-block;
        background-color: $warning-color;
        margin-right: 4px;
    }
}
</style>
